import React from 'react'
import CurrencySelector from './CurrencySelector'
import { Coins, Zap } from 'lucide-react'
import { useNavigate } from "react-router-dom";
const Header = () => {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200">
  <div className="max-w-7xl mx-auto px-4 sm:px-4 lg:px-4 h-18 py-2 flex items-center justify-between">
    
    {/* LEFT */}
    <div className="flex items-center gap-4">
      <img src="/logo.jpeg" className="h-10 w-10 rounded-lg" alt="logo" />

      <div className="leading-tight">
        <h1 className="text-lg font-bold text-slate-900">
          EV Charging Station
        </h1>
        <p className="text-xs text-slate-500">
          ROI & Cost Calculator
        </p>
      </div>

      <button
        onClick={() => navigate("/admin/table")}
        // className="ml-6 text-sm underline font-medium text-slate-600 hover:text-slate-900"
      className="hidden md:inline-block ml-6 text-sm underline font-medium text-slate-600 hover:text-slate-900"
>
        My Saved Projects
      </button>
    </div>

    {/* RIGHT */}
    <div className="flex items-center gap-3">
      <CurrencySelector />
    </div>

  </div>
</header>

  )
}

export default Header